<template>
  <div
    class="user-selection-container"
    style="width:100%; display: flex; justify-content: center"
  >
    <div style="width: 100%">
      <VTableLocal
        :items="usersList"
        :headers="headersTitle"
        disablePagination
      >
        <template #item.fullName="{ item }">
          <div>{{ item.fullName }}</div>
        </template>
        <template #item.alert="{ item }">
          <div
            style=""
            class="frameCheckboxes"
          >
            <VCheckbox
              :label="$t('forms.labels.notifyEmail')"
              :disabled="isCheckboxDisabled(item.alert.email)"
              :readonly="readOnly"
              :value="getItem(item).email"
              datacy="alertedUsersCheckboxForAlert"
              @input="(val)=>onChecboxChange(val,'email',item)"
            />
            <VCheckbox
              :label="$t('forms.labels.notifySms')"
              :disabled="isCheckboxDisabled(item.alert.sms)"
              :readonly="readOnly"
              :value="getItem(item).sms"
              @input="(val)=>onChecboxChange(val,'sms',item)"
            />
            <VCheckbox
              :label="$t('forms.labels.notifyApp')"
              :disabled="isCheckboxDisabled(item.alert.app)"
              :readonly="readOnly"
              :value="getItem(item).app"
              @input="(val)=>onChecboxChange(val,'app',item)"
            />
            <span
              v-if="!readOnly"
              class="crossBox"
              @click="onUserRemove(item)"
            >
              <v-icon small>
                mdi-close
              </v-icon>
            </span>
          </div>
        </template>
      </VTableLocal>
    </div>
  </div>
</template>
<script>

import { cloneDeep } from 'lodash';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import VCheckbox from '../shared/widgets/forms/VuetifyInputs/VCheckbox.vue';

export default {
    components: { VCheckbox, VTableLocal },
    props: {
        usersList: {
            type: Array,
            default: () => [{ name: 'John Done', id: 1 }],
        },
        alertedUsers: {
            type: Object,
            default: () => { },
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        addedUsers: {
            type: Array,
            default: () => [],
        },
        deletedUsers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            userSelection: {},
            usersArr: [],
            newAddedUsers: [],
            headers: [{ text: this.$t('forms.labels.name'), value: 'fullName' }, { text: this.$t('forms.labels.tableColumnAlertedBy'), value: 'alert' }],
        };
    },
    computed: {
        headersTitle() {
            const headerName = this.headers.map(item => ({
                text: item.text, // TODO traduction à faire avant la mise en prod
                value: item.value,
            }));
            return headerName;
        },
    },
    watch: {
        addedUsers: {
            handler(addedUser) {
                // If a new user(member) added to the alerted people list, the app option is selected by default
                addedUser.forEach(member => {
                    this.userSelection[member.memberId || member.contactId] = {
                        app: member.memberId && member.memberId.length ? true : null,
                        isContact: !!(member.contactId && member.contactId.length),
                        isMember: !!(member.memberId && member.memberId.length),
                    };
                });

                this.$emit('selectonChange', this.userSelection);
            },
        },
        deletedUsers: {
            handler(deleteduser) {
                deleteduser.forEach(id => {
                    delete this.userSelection[id];
                });

                this.$emit('selectonChange', this.userSelection);
            },
        },
        usersList: {
            immediate: true,
            handler(newValue) {
                this.usersArr = newValue;
            },
        },
    },
    created() {
        if (this.alertedUsers.initValue) {
            const obj = {};
            this.alertedUsers.initValue.forEach(entity => {
                obj[entity.memberId || entity.contactId] = {
                    email: entity.email,
                    sms: entity.sms,
                    app: entity.app,
                    isMember: !!entity.memberId,
                    isContact: !!entity.contactId,
                };
            });
            this.userSelection = cloneDeep(obj);
            this.$emit('selectonChange', this.userSelection);
        }
    },
    methods: {
        isCheckboxDisabled(fieldVal) {
            return fieldVal === null;
        },
        getUserId(user) {
            return user.memberId || user.contactId;
        },
        getUserCheckboxVal(user, mode) {
            const memberId = this.getUserId(user);
            let temp = false;
            if (this.userSelection[memberId]) {
                temp = this.userSelection[memberId][mode];
            }
            return temp;
        },
        onUserRemove(user) {
            const memberId = this.getUserId(user);

            /* Search the index by the memberID */


            const index = this.usersArr.findIndex(element => element.memberId === memberId);

            this.usersArr.splice(index, 1);
            delete this.userSelection[memberId];
            this.$emit('selectonChange', this.userSelection, index);
        },
        onChecboxChange(checkboxVal, mode, user) {
            const memberId = this.getUserId(user);
            if (this.userSelection[memberId]) {
                this.userSelection[memberId][mode] = checkboxVal;
            } else {
                this.userSelection[memberId] = { [mode]: checkboxVal, isMember: !!user.memberId, isContact: !!user.contactId };
            }
            this.$emit('selectonChange', this.userSelection);
        },
        getItem(item) {
            return this.userSelection[item.memberId || item.contactId];
        },
    },
};
</script>
<style scoped>
    .alter-mode-row .mode-span{
        margin-right: 15px;
    }
    .crossBox {
      display: flex;
      align-items: center;
      margin-left: 5px
    }
    .frameCheckboxes {
      display:flex;
      flex-direction:row;
    }

      .frameCheckboxes > :nth-child(n) {
        margin-left: 15px;
      }

      @media screen and (max-width: 800px) {
        .frameCheckboxes {
          display:flex;
          flex-direction:column;
        }
      }

</style>
